export const TeamContent = () => {
    return (
        <section className="section-shell">
            <div className="section-block">
                <p className="section-body mb-8">
                    In D&D, we have appointed best of the best trainers who has
                    been performing well in the market to train and deliver the
                    knowledge of real estate selling technique for everyone.
                </p>
            </div>

            <div className="section-block section-block--wide">
                <h2 className="section-title">D&D TRAINERS</h2>
                <img
                    className="w-full h-auto"
                    src="https://venti-fans.com/wp-content/uploads/2026/04/DD_Website_Trainer2026.png"
                    alt=""
                />
            </div>

            <div className="section-block">
                <h2 className="section-title">D&D CLASSES</h2>
                <p className="section-body mb-6">
                    Weekly intensive calsses to educate our agents with
                    real-time real estate knowledge to master the market.
                </p>
                <p className="section-body">
                    Calling Skill • Closing Skill • How To Get Potential Leads
                    How To Be The Star In Real Estate Market & etc.
                </p>
            </div>

            <hr className="section-rule" />

            <div className="section-block">
                <p className="section-body mb-8">
                    With all the skills and knowledge delivered, we have
                    successfully:
                </p>
                <div className="uppercase tracking-wide text-[var(--brand-muted)] mb-3">
                    SOLD OVER
                </div>
                <div className="section-stat mb-3">8,082</div>
                <div className="uppercase tracking-wide text-[var(--brand-muted)]">
                    UNITS IN 2024
                </div>
            </div>

            <hr className="section-rule" />

            <div className="section-block">
                <div className="uppercase tracking-wide text-[var(--brand-muted)] mb-3">
                    ACHIEVED GDV OF
                </div>
                <div className="section-stat mb-3" style={{ fontSize: "clamp(2rem, 6vw, 4.5rem)" }}>
                    3,967,962,968
                </div>
                <div className="uppercase tracking-wide text-[var(--brand-muted)]">
                    IN 2024
                </div>
            </div>
        </section>
    );
};
